var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-container-component p-3 br-8 fs-14",class:{access: _vm.access}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }